<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="false"
  appendTo="body"
  styleClass="cancel-dialog"
  [style]="{ width: '25rem', maxWidth: 'calc(100vw - 2rem)' }"
>
  <ng-template #header>
    <div class="flex align-items-start justify-content-between w-full">
      <div class="flex justify-content-center align-items-center dialog-header-icon">
        <app-slash-circle-01 stroke="#414651" width="20px" height="20px"></app-slash-circle-01>
      </div>
      <app-x-close
        stroke="#ADB0B8"
        width="12"
        height="12"
        class="cursor-pointer"
        (click)="onCancel()"
      ></app-x-close>
    </div>
  </ng-template>

  <div class="flex flex-column gap-3">
    <div class="flex flex-column">
      <div class="text-lg-semibold text-gray-900">Otkažite termin</div>
      <div class="text-sm-regular text-gray-600 mt-1">
        Da li ste sigurni da želite da otkažete ovaj termin? Otkazivanje se ne može poništiti.
      </div>
    </div>

    @if (details(); as d) {
      <div class="summary-card bg-gray-50 flex flex-column gap-2">
        <div class="summary-row">
          <div class="summary-label">
            <app-calendar stroke="#A4A7AE" width="16px" height="16px"></app-calendar>
            <div class="text-sm-regular text-gray-600">Datum</div>
          </div>
          <div class="text-sm-medium text-gray-900">{{ formatLongSrDate(d.from!) }}</div>
        </div>
        <div class="summary-row">
          <div class="summary-label">
            <app-clock stroke="#A4A7AE" width="16px" height="16px"></app-clock>
            <div class="text-sm-regular text-gray-600">Vreme</div>
          </div>
          <div class="text-sm-medium text-gray-900">{{ formatTimeRange(d.from!, d.to!) }}</div>
        </div>
        <div class="summary-row">
          <div class="summary-label">
            <app-hourglas-03 stroke="#A4A7AE" width="16px" height="16px"></app-hourglas-03>
            <div class="text-sm-regular text-gray-600">Trajanje</div>
          </div>
          <div class="text-sm-medium text-gray-900">{{ d.duration }}h</div>
        </div>
      </div>

      <div class="info-block flex align-items-start gap-2">
        @if (isShortNotice()) {
          <app-alert-triangle stroke="#DC6803" width="16px" height="16px"></app-alert-triangle>
        } @else {
          <app-info-circle stroke="#2970FF" width="16px" height="16px"></app-info-circle>
        }
        <div class="flex flex-column gap-1">
          @if (isShortNotice()) {
            <div class="text-sm-semibold text-gray-900">Rok za besplatno otkazivanje je istekao</div>
            <div class="text-sm-regular text-gray-700">
              Sati ovog termina ({{ d.duration }}h) neće biti vraćeni na vaš nalog.
            </div>
          } @else {
            <div class="text-sm-semibold text-gray-900">Otkazivanje je besplatno</div>
            <div class="text-sm-regular text-gray-700">
              Sati ovog termina ({{ d.duration }}h) biće vraćeni na vaš nalog i možete ih iskoristiti za novi termin.
            </div>
          }
        </div>
      </div>
    }
  </div>

  <ng-template #footer>
    <div class="dialog-footer">
      <app-button
        [btnSeverity]="ButtonSeverity.SECONDARY"
        [btnSize]="ButtonSize.MD"
        (btnClicked)="onCancel()"
      >
        <div class="text-sm-semibold text-gray-900">Odustani</div>
      </app-button>
      <app-button
        [isDestructive]="true"
        [btnSeverity]="ButtonSeverity.PRIMARY"
        [btnSize]="ButtonSize.MD"
        (btnClicked)="onConfirm()"
      >
        <div class="text-sm-semibold text-white">Otkaži termin</div>
      </app-button>
    </div>
  </ng-template>
</p-dialog>
